import React, { Component } from "react";
import PropTypes from "prop-types";
import FormPanel from "../../components/FormPanel";
import DetailsPanel from "../../components/DetailsPanel";

class CalculatorTemplate extends Component {
  state = {
    showDetails: false
  };

  static propTypes = {
    formData: PropTypes.object.isRequired,
    schema: PropTypes.object.isRequired,
    uiSchema: PropTypes.object.isRequired,
    pageContent: PropTypes.object.isRequired,
    onCloseResults: PropTypes.func.isRequired
  };

  render() {
    const {
      pageContent,
      formData,
      schema,
      uiSchema,
      onSubmit,
      updateFormData,
      showDetailsPanel,
      loanCalculationResults,
      onCloseResults
    } = this.props;

    return (
      <>
        <FormPanel
          pageContent={pageContent}
          formData={formData}
          schema={schema}
          uiSchema={uiSchema}
          onSubmit={onSubmit}
          updateFormData={updateFormData}
        />
        {showDetailsPanel ? (
          <DetailsPanel
            loanCalculationResults={loanCalculationResults}
            pageContent={pageContent}
            onCloseResults={onCloseResults}
          />
        ) : null}
      </>
    );
  }
}

CalculatorTemplate.propTypes = {};

export default CalculatorTemplate;
